import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Swipeable } from 'react-swipeable'
import { Icon } from 'pp-react'
import cs from 'classnames'

import styles from './imageCarousel.module.css'

// https://stackoverflow.com/questions/3646036/preloading-images-with-javascript#comment41680303_3646036
const preloadImages = urls =>
  // eslint-disable-next-line no-return-assign
  urls.forEach(url => (new Image().src = url))

const ImageCarousel = ({ previewURLs = [] }) => {
  const [curIndex, setCurIndex] = useState(0)

  const setPrev = () => setCurIndex(curIndex - 1)
  const setNext = () => setCurIndex(curIndex + 1)

  // preload all carousel images we you don't have to wait for them to load
  // when clicking the previous/next arrows
  useEffect(() => preloadImages(previewURLs), [previewURLs])

  return (
    <div>
      <div className={cs(styles.container, styles['container--viewmode'])}>
        <div className={styles.controls}>
          {curIndex > 0 ? (
            <Icon
              name="chevron-left"
              size="xl2"
              className={styles.prev}
              onClick={setPrev}
              tabIndex={-1}
              role="button"
            />
          ) : null}
          {curIndex < previewURLs.length - 1 ? (
            <Icon
              name="chevron-right"
              size="xl2"
              className={styles.next}
              onClick={setNext}
              tabIndex={-1}
              role="button"
            />
          ) : null}
        </div>
        <Swipeable
          className={cs(
            styles.imageContainer,
            styles['imageContainer--viewmode'],
          )}
          onSwipedLeft={() =>
            setCurIndex(curIndex !== 0 ? curIndex - 1 : previewURLs.length - 1)
          }
          onSwipedRight={() =>
            setCurIndex(curIndex !== previewURLs.length - 1 ? curIndex + 1 : 0)
          }
        >
          <div
            className={cs(
              styles.imageContainer,
              styles['imageContainer--viewmode'],
            )}
            style={{ backgroundImage: `url(${previewURLs[curIndex]})` }}
          />
        </Swipeable>
      </div>
      <div
        className={cs(styles.dotContainer, styles['dotContainer--viewmode'])}
      >
        {previewURLs.map((previewURL, index) => (
          <span
            key={index}
            onClick={() => {
              setCurIndex(index)
            }}
            className={cs(styles.dot, index === curIndex && styles.dotSelected)}
          />
        ))}
      </div>
    </div>
  )
}

ImageCarousel.propTypes = {
  previewURLs: PropTypes.array,
}

export default ImageCarousel
